import CountriesService from '@/services/geo.countries.service';

export const state = {
    countries: JSON.parse(localStorage.getItem('countries')),
};

export const actions = {
    async fetchCountries({ state, commit }) {
        if (state.countries && state.countries.length && state.countries.length > 1) {
            return state.countries;
        }
        const res = await CountriesService.getCountriesAll();
        commit('setNatureOfBusiness', { countries: res.data.countries });
        return res.data.countries;
    },
};

export const mutations = {
    setNatureOfBusiness: (state, { countries }) => {
        state.countries = countries;
        localStorage.setItem('countries', JSON.stringify(countries));
    },
};
